import { useQuery } from '@tanstack/react-query';
import useWorkspaceSystem from '../systems/useWorkspaceSystem';
import { QueryKeys } from './keysAndFilters';

const useNonMembersQuery = ( workspaceID: number ) => {
	const system = useWorkspaceSystem();

	return useQuery(
		QueryKeys.forNonMembers( { workspaceID } ),
		() => system.fetchNonMembers( { workspaceID } ),
		{ staleTime: 0, refetchOnWindowFocus: true }
	);
};

export default useNonMembersQuery;
